import { contactFormSubmissionsCollection } from '../firebase';

const create = (data) => {
    return contactFormSubmissionsCollection.add(data);
};

export {
    create,
}
